/**
 * utils/caseNaming.ts
 *
 * Generates the default name for a client case (dossier) based on a reference date.
 * Format: "Dossier du JJ/MM/AAAA" — matches the SQL trigger convention.
 */

export function buildCaseName(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return 'Nouveau dossier';
  const formatted = d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return `Dossier du ${formatted}`;
}
